import Vuex from "vuex";
import Vue from "vue";
import { functions } from "@/utils/functions";

Vue.use(Vuex);

export const dialysis_sessions = {
  namespaced: true,
  state: () => ({
    dialysis_sessions: null,
    dialysis_session: null,
    enough_fund: null,
    not_enough_fund: null,
  }),
  mutations: {
    SET_DIALYSIS_SESSIONS(state, sessions) {
      state.dialysis_sessions = sessions;
    },
    SET_DIALYSIS_SESSION(state, session) {
      state.dialysis_session = session;
    },
    SET_NOT_ENOUGH_FUND(state, data) {
      state.not_enough_fund = data;
    },
    SET_ENOUGH_FUND(state, data){
      state.enough_fund = data;
    }
  },
  actions: {
    fetchDialysisSessions({ commit }, queryParams = {}) {
      this.$store.dispatch("loading/triggerTableLoader");
      const url = `encoder/dialysis/sessions`;
      const query = functions.query(url, queryParams);

      return this.$axios
        .get(query)
        .then((response) => {
          const sessions = response.data.dialysis_sessions;
          commit("SET_DIALYSIS_SESSIONS", sessions);
        })
        .catch((error) => {
          console.error("Error Fetching Dialysis Sessions", error);
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerTableLoader");
        });
    },
    fetchDialysisSessionById({ commit }, id) {
      const url = `encoder/dialysis/sessions/${id}`;
      return this.$axios
        .get(url)
        .then((response) => {
          const session = response.data.dialysis_session;
          commit("SET_DIALYSIS_SESSION", session);
        })
        .catch((error) => {
          console.error("Error Fetching Dialysis Session", error);
        });
    },
    completeDialysisSessionById({ dispatch }, id) {
      this.$store.dispatch("loading/triggerFunctionLoader", "submit");
      const url = `encoder/dialysis/sessions/${id}/complete`;
      return this.$axios
        .patch(url)
        .then((response) => {
          dispatch("fetchDialysisSessionById", id);
          //Success Alert
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
        })
        .catch((error) => {
          console.error("Error Patching Dialysis Session: ", error);
          //Failed Alert
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "submit");
        });
    },
    toggleServiceProgress({ dispatch }, { hospital_service_id, id, status }) {
      this.$store.dispatch("loading/triggerFunctionLoader", "submit");
      const url = `hospital-services/${hospital_service_id}/toggle-status`;
      return this.$axios
        .patch(url, status)
        .then((response) => {
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
          dispatch("fetchDialysisSessionById", id);
        })
        .catch((error) => {
          console.error("Error Patching Status: ", error);
          //Failed Alert
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "submit");
        });
    },
    resetDialysisSessions({ commit }) {
      commit("SET_DIALYSIS_SESSIONS", null);
    },
    resetDialysisSession({ commit }) {
      commit("SET_DIALYSIS_SESSION", null);
    },
    checkEnoughFund({ commit }, payload) {
      this.$store.dispatch("loading/triggerFunctionLoader", "submit");
      const url = `enums/hospital-services/funders/checkDialysisFunder`;
      let data = { schedule: [...payload.schedule] }

      payload.schedule.map((item, index) => {
        data.schedule[index] = {
          date: item.date,
          session: item.session,
          dialysis_packages: []
        }
        item.dialysis_packages.map((dialysis_package) => {
          data.schedule[index].dialysis_packages.push({
            name: dialysis_package.name,
            funder: dialysis_package.funder
          })
        })
      })
      return this.$axios
        .post(url, data)
        .then((response) => {
          commit("SET_ENOUGH_FUND", response);
          commit("SET_NOT_ENOUGH_FUND", null);
        })
        .catch((error) => {
          // console.error("Error in Checking Funder", error);
          this.$store.commit("alerts/SET_SHOW_ERROR", error.response.data.message)
          commit("SET_NOT_ENOUGH_FUND", error.response.data);
          commit("SET_ENOUGH_FUND", null);
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "submit");
        })
    }
  },
};

export const dialysis_sessions_packages = {
  namespaced: true,
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {
    updateDialysisSession(_, { id, data }) {
      this.$store.dispatch("loading/triggerFunctionLoader", "submit");
      const url = `encoder/dialysis/sessions/${id}/packages/create-or-update`;
      return this.$axios
        .post(url, data)
        .then((response) => {
          this.$store.dispatch(
            "dialysis_sessions/fetchDialysisSessionById",
            id
          );
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
        })
        .catch((error) => {
          console.error("Error Updating Dialysis Session: ", error);
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "submit");
        });
    },
    deleteDialysisPackageById(
      _,
      { dialysis_session_id, dialysis_session_package_id }
    ) {
      this.$store.dispatch("loading/triggerFunctionLoader", "delete");
      const url = `encoder/dialysis/sessions/${dialysis_session_id}/packages/${dialysis_session_package_id}`;

      return this.$axios
        .delete(url)
        .then((response) => {
          this.$store.dispatch(
            "dialysis_sessions/fetchDialysisSessionById",
            dialysis_session_id
          );
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
        })
        .catch((error) => {
          console.error("Error Deleting Dialysis Session Package: ", error);
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "delete");
        });
    },
  },
};
